import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { styled, useTheme } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import { MenuSideBar } from "./MenuSideBar";
import { useHistory } from "react-router-dom";
import { APP_WEB_URL } from "../../Utils/enviromentApp.js";
import { useSelector } from "react-redux";
import { Notification } from "./Notification.jsx";
import { TICKET_TYPE } from "../../constants.js";

const drawerWidth = 320;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function MenuAppBar({ children, onOpenFaqs }) {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [auth, setAuth] = React.useState(true);

  const history = useHistory();
  const userLogged = useSelector(
    (store) => store.authentication.authenticatedUser
  );
  const tickets = useSelector((store) => store?.tickets?.data?.tickets);

  const handleRedirect = (path) => history.push(path);
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleSignOut = (e) => {
    window.location.href = `${APP_WEB_URL}/Account/SignOut`;
    handleClose();
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      {/*      <Box sx={{ display: 'flex' }}> */}
      <AppBar position="fixed" open={open} theme={theme}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={handleDrawerOpen}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Portal Cupa
          </Typography>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            {
              <Notification
                notifications={[
                  {
                    name: "Interferencias",
                    quantity: tickets.filter(
                      (ticket) =>
                        ticket.type === TICKET_TYPE.INTERFERENCE &&
                        ticket.status !== 6
                    ).length,
                    url: "/ListadoConsultas",
                    type: "interferencia",
                  },
                ]}                
              />
            }
            {auth && (
              <div>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                  <AccountCircle style={{ marginLeft: "3px" }} />
                  <Typography variant="subtitle1">
                    {userLogged.email}
                  </Typography>
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  {/* <MenuItem onClick={handleClose}>Profile</MenuItem> */}
                  <MenuItem onClick={handleSignOut}>Sign Out </MenuItem>
                </Menu>
              </div>
            )}
          </div>
        </Toolbar>
      </AppBar>
      <MenuSideBar
        open={open}
        toolbar={<Toolbar />}
        handleClose={handleClose}
        handleDrawerClose={handleDrawerClose}
        theme={theme}
        userLogged={userLogged}
        onOpenFaqs={onOpenFaqs}
      />
      {children}
      {/*      <Copyright />
       */}{" "}
    </>
  );
}
